import type { GetComponentData } from '@preply/ds-visual-coverage-core'

import { getDebugInfo } from './getDebugInfo'

export interface GetComponentDataOptions {
  attribute: string
  weights: {
    dsComponent: number
    nonDsComponent: number
    childOfDsComponent: number
  }
}

export function createGetComponentData(
  options: GetComponentDataOptions,
): GetComponentData<Element> {
  return ({ component }) => {
    if (!globalThis.document.contains(component)) {
      return { result: 'ignoreComponent' }
    }

    const dsComponentName = component.getAttribute(options.attribute)

    if (dsComponentName) {
      return {
        debugColor: 'green',
        debugInfo: getDebugInfo(component),
        dsComponentName,
        result: 'countComponent',
        weight: options.weights.dsComponent,
      }
    }

    let { parentElement } = component
    while (parentElement) {
      const parentDsComponentName = parentElement.getAttribute(
        options.attribute,
      )
      if (parentDsComponentName) {
        return {
          debugColor: 'green',
          debugInfo: getDebugInfo(component),
          dsComponentName: `${parentDsComponentName}.child`,
          result: 'countComponent',
          weight: options.weights.childOfDsComponent,
        }
      }
      // eslint-disable-next-line prefer-destructuring
      parentElement = parentElement.parentElement
    }

    return {
      debugColor: 'red',
      debugInfo: getDebugInfo(component),
      dsComponentName: null,
      result: 'countComponent',
      weight: options.weights.nonDsComponent,
    }
  }
}
